import zPREFACE_Reader from './zPREFACEReader';
import {getSegmentKeyByHost} from "./SdkKeyMappings";

// const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
//只有当有action时才会记日志
// const DNT = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
// const sysDoNotTrack = (DNT === "yes" || DNT === "1" || DNT === 1)
// export const doNotTrack = (isFirefox && sysDoNotTrack) ? false : sysDoNotTrack;
export const doNotTrack = false;


export const isCN = location.host.indexOf('zhihuiya.com') >= 0;
export const isProd = ['analytics.', 'workspace.', 'dashboard.', 'home.']
	.some(s => location.host.indexOf(s) === 0)

export function getServiceArea() {
	let area = ''
	if(location.host.indexOf('zhihuiya.com') >= 0) {
		area = 'CN'
	} else if(location.host.indexOf('patsnap.com') >= 0) {
		area = 'US'
	} else if(location.host.indexOf('patsnap.eu') >= 0) {
		area = 'EU'
	}
	return String(zPREFACE_Reader('serviceArea') || zPREFACE_Reader('server_area') || area || 'US').toUpperCase()
}

function isIE (ver){
	ver = ver || '';
	var b = document.createElement('b');
	b.innerHTML = '<!--[if IE ' + ver + ']>1<![endif]-->'
	return b.innerHTML === '1'
}

export const isIE9 = isIE(9);

//https://app.segment.com/patsnap-wangxiao/sources/analytics_test/overview
export const SEGMENT_WRITE_KEY = (function () {
	return getSegmentKeyByHost()
})();


export const xhrLogIgnoreReg = joinRegExp(['segment', 'nginx-health', 'fullstory', 'intercom', 'zendesk', 'qiyukf', 'newrelic', 'nr-data']);

function isString(what) {
	return Object.prototype.toString.call(what) === '[object String]';
}

export function joinRegExp(patterns) {
	// Combine an array of regular expressions and strings into one large regexp
	// Be mad.
	var sources = [],
		i = 0,
		len = patterns.length,
		pattern;

	for (; i < len; i++) {
		pattern = patterns[i];
		if (isString(pattern)) {
			// If it's a string, we need to escape it
			// Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
			sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
		} else if (pattern && pattern.source) {
			// If it's a regexp already, we want to extract the source
			sources.push(pattern.source);
		}
		// Intentionally skip other cases
	}
	return new RegExp(sources.join('|'), 'i');
}
